import { currencyFormatter, dateFormatter, hexToRgbA } from "../../utils/formatter";

export const createCardFour = (plan) => {

  let currentColor = plan.membershipColor;
  if (!currentColor.includes('rgb')) {
    currentColor = hexToRgbA(plan.membershipColor);
  }
  const packageColor = 'rgba' + currentColor.slice(3, currentColor.length - 1).concat(',0.95)');

  return `
    <div class="subscription-card-four">
      <div class="subscription-card-four-header" style="background-color: ${packageColor}">
        <div class="subscription-card-four-title" style="background-color: ${plan.membershipColor}">${plan.title}</div>
        <div class="subscription-card-four-info">
          <div class="subscription-card-four-price text-weight-bold" style="display: ${plan.isDiscount ? 'block' : 'none'}">
            ${currencyFormatter.format(plan.discountedPriceValue)}
          </div>
          <div class="subscription-card-four-text-discount text-weight-bold ${plan.isDiscount ? 'per-month' : ''}">
            ${currencyFormatter.format(plan.regularPriceInput)} / ${plan.regularPriceSelect}
          </div>
          <div class="text-des subscription-card-four-discount-info" style="display: ${plan.isDiscount ? 'block' : 'none'}">
            Valid until <span class="text-weight-bold">${dateFormatter(plan.discountFor)}</span>
          </div>
        </div>
      </div>
      <div class="subscription-card-four-content">
        <div class="text-weight-bold subscription-card-four-num" style="display: ${plan.isFree ? 'block' : 'none'}">
          ${plan.trialPeriodInput}
        </div>
        <div class="text-weight-bold subscription-card-four-free-trial" style="display: ${plan.isFree ? 'block' : 'none'}">
          ${plan.trialPeriodSelect} Free Trial
        </div>
        <div class="text-des subscription-card-four-text-des">
          ${plan.description}
        </div>
      </div>
      <div class="subscription-card-four-actions">
        <a class="subscription-card-four-button subscription-card-btn-purchase" style="background-color: ${plan.btnAddColor}"">PURCHASE</a>
      </div>
    </div>
  `
}